import React, { useEffect, useState } from "react";
import {
  Layout,
  Input,
  Button,
  Select,
  Tabs,
  Typography,
  Upload,
  message,
  Spin,
} from "antd";
import TopBar from "../../../Topbar/Header";
import HeaderAITool from "../../../../assets/img/header.png";
import secondPicture from "../../../../assets/img/layer_.png";
import "./index.css";
import axios, { AxiosRequestConfig } from "axios";
import TranslationModal from "../../../modals/TranslationModal";
import ModalImage from "../../../../assets/img/Frame.png";
import { RcFile } from "antd/es/upload";
import {
  DownloadOutlined,
  CopyOutlined,
  ArrowLeftOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import { get, getBlob, post } from "../../../../utils/apiUtils";
import { getUserRole } from "../../../../hooks/getUserRoles";
import { useParams } from "react-router-dom";
import { useGate } from "../../../Subscription/entitlements";
import { normalizeRole } from "../../../../utils/roles";
import { useTranslation } from "react-i18next";

const { Content } = Layout;
const { TextArea } = Input;
const { TabPane } = Tabs;
const { Option } = Select;
const { Title } = Typography;
const { Dragger } = Upload;

type LanguageType = {
  id: string;
  name: string;
  code: string;
};

function AITranslation() {
  const { t } = useTranslation("aiTools");
  const userRole = getUserRole();
  const { id: projectId } = useParams();
  const gate = useGate();
  const [activeTab, setActiveTab] = useState("1"); // State to keep track of active tab
  const [fileList, setFileList] = useState<RcFile[]>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [translationId, setTranslationId] = useState(null); // You'll need to set this to the correct id after the translation is done
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [jsonInput, setJsonInput] = useState("");
  const [supportedLanguages, setSupportedLanguages] = useState<LanguageType[]>(
    []
  );

  const [language, setLanguage] = useState("");
  const [jsonName, setJsonName] = useState("");
  const [textName, setTextName] = useState("");
  const [excelName, setExcelName] = useState("");
  const [textInput, setTextInput] = useState("");

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    const fetchSupportedLanguages = async () => {
      setIsLoading(true);
      try {
        const response = await get("supported_languages/", {
          headers: {
            Accept: "application/json",
          },
        });
        if (response.type === "success") {
          setSupportedLanguages(response.data as LanguageType[]);
        } else {
          throw new Error("Failed to fetch supported languages");
        }
      } catch (error: any) {
        console.error(
          "There was an error fetching the supported languages:",
          error
        );
        message.error(
          t("addTranslation.messages.fetchLanguagesError", {
            message: error.message,
          })
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchSupportedLanguages();
  }, []);

  const handleLanguageChange = (value: string) => {
    setLanguage(value);
  };
  const token = localStorage.getItem("token");

  const translateJson = async () => {
    if (!jsonInput.trim() || !language) {
      message.error(t("addTranslation.messages.selectFileAndLanguage"));
      return;
    }

    const formData = new URLSearchParams();

    formData.append("json_data", jsonInput);
    formData.append("to_lang", language);
    if (projectId) {
      formData.append("project_id", projectId);
    } else {
      throw new Error("Project ID is undefined");
    }

    const token = localStorage.getItem("token");
    setIsLoading(true); // Start loading

    try {
      const response = await post<any>("translate_json_endpoint/", formData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.type === "success") {
        message.success(t("addTranslation.messages.translationSuccess"));
        setTranslationId(response?.data?.translation_id);
        setJsonName(response?.data?.filename);
        setIsModalVisible(true);
        setIsLoading(false);
        gate.refresh();
      } else {
        throw new Error(`HTTP error! status: ${response.type}`);
      }
    } catch (error: any) {
      message.error(`Translation failed: ${error.message}`);
      setIsLoading(false);
    }
  };

  // Translation function for file upload
  const onFileChange = (info: any) => {
    const { file, fileList } = info;

    if (file.status !== "uploading") {
      console.log(file, fileList);
    }

    if (file.status === "done") {
      message.success(
        t("addTranslation.messages.fileSelected", { filename: file.name })
      );
    } else if (file.status === "error") {
      message.error(
        t("addTranslation.messages.fileSelectionFailed", {
          filename: file.name,
        })
      );
    }

    // RUJ file-at komplet, mos ja hek originFileObj
    const newFileList = fileList as RcFile[];

    setFileList(newFileList);
  };

  const translateFile = async () => {
    if (fileList.length === 0 || !language) {
      message.error(t("addTranslation.messages.selectFileAndLanguage"));
      return;
    }

    const fileToUpload = (fileList[0] as any).originFileObj as File;
    const formData = new FormData();
    formData.append("file", fileToUpload);
    formData.append("to_lang", language);
    if (projectId) {
      formData.append("project_id", projectId);
    } else {
      throw new Error("Project ID is undefined");
    }
    setIsLoading(true); // Start loading

    try {
      let headers: AxiosRequestConfig["headers"] = {
        "Content-Type": "application/x-www-form-urlencoded",
      };

      const response = await post<any>("translate_excel_file/", formData, {
        headers: {
          // Lene browser-in me vendos Content-Type multipart/form-data
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.type == "success") {
        setTranslationId(response.data.translation_id);
        setExcelName(response?.data?.filename);
        message.success(t("addTranslation.messages.translationStarted"));
        setIsModalVisible(true);
        setIsLoading(false);
        gate.refresh();
      } else {
        throw new Error(`HTTP error! status: ${response.type}`);
      }
    } catch (error) {
      message.error(t("addTranslation.messages.translationError"));
      console.error("Translation error:", error);
      setIsLoading(false);
    }
  };

  const translateText = async () => {
    if (!textInput.trim() || !language) {
      message.error(t("addTranslation.messages.selectFileAndLanguage"));
      return;
    }

    const formData = new URLSearchParams();
    formData.append("text", textInput);
    formData.append("to_lang", language);
    if (projectId) {
      formData.append("project_id", projectId);
    } else {
      throw new Error("Project ID is undefined");
    }

    try {
      const token = localStorage.getItem("token");
      setIsLoading(true); // Start loading

      let headers: AxiosRequestConfig["headers"] = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      };

      const response = await post<any>("translate_text_endpoint/", formData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.type == "success") {
        message.success(response?.data?.message);
        setTranslationId(response?.data?.translation_id);
        setTextName(response?.data?.filename);
        setIsModalVisible(true);
        setIsLoading(false);
        gate.refresh();
      } else {
        throw new Error(`HTTP error! status: ${response.type}`);
      }
    } catch (error) {
      console.error("There was an error translating the text:", error);
      message.error(t("addTranslation.messages.translationFailed"));
      setIsLoading(false);
    }
  };

  const translate = () => {
    if (activeTab === "1") {
      translateJson();
    } else if (activeTab === "2") {
      translateFile();
    } else if (activeTab === "3") {
      translateText();
    }
  };

  const handleDownload = async () => {
    if (!translationId) {
      message.error(t("addTranslation.messages.noTranslationToDownload"));
      return;
    }

    let filename = "downloaded_file";
    if (activeTab === "1") {
      filename = jsonName || "json_translation";
    } else if (activeTab === "2") {
      filename = excelName || "excel_translation";
    } else if (activeTab === "3") {
      filename = textName || "text_translation";
    }

    setIsLoading(true); // Optional, if you have a loading state
    try {
      const response = await getBlob<Blob>(
        `translations/download/${translationId}?project_id=${projectId}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.type === "success") {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"] || "application/octet-stream",
        });
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();

        // Clean up after download
        document.body.removeChild(link);
        URL.revokeObjectURL(downloadUrl);
        message.success(t("addTranslation.messages.downloadStarted"));
      } else {
        throw new Error("Failed to download the file.");
      }
    } catch (error: any) {
      console.error("Download error:", error);
      message.error(
        t("addTranslation.messages.downloadFailed", {
          message: error.message,
        })
      );
    } finally {
      setIsLoading(false); // Optional, to manage loading state
    }
  };

  const handleCopy = async () => {
    if (!translationId) {
      message.error(t("addTranslation.messages.noTranslationToCopy"));
      return;
    }

    setIsLoading(true); // Start loading

    try {
      const response = await getBlob<Blob>(
        `copy_translation/${translationId}?project_id=${projectId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          responseType: "blob",
        }
      );

      if (response.type === "success") {
        // Convert the blob to text
        const text = await response.data.text();
        try {
          const json = JSON.parse(text);
          if (json.content && typeof json.content === "object") {
            await navigator.clipboard.writeText(JSON.stringify(json.content));
          } else {
            await navigator.clipboard.writeText(json.content || text);
          }
          message.success(t("addTranslation.messages.copySuccess"));
        } catch (e) {
          // If JSON.parse fails, assume the response was plain text
          await navigator.clipboard.writeText(text);
          message.success(t("addTranslation.messages.textCopySuccess"));
        }
      } else {
        throw new Error("Failed to fetch translation for copying.");
      }
    } catch (error: any) {
      console.error("Error copying the translation:", error);
      message.error(
        t("addTranslation.messages.copyFailed", { message: error.message })
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ padding: "2rem" }}>
      <Content
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundColor: "white",
        }}
      >
        <div
          style={{
            position: "relative",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 1,
          }}
        >
          <img
            src={HeaderAITool}
            alt="AI Tool Header"
            style={{ width: "100%", height: "auto" }}
          />
        </div>

        <div className="translation-add-tool-content">
          <div>
            <Title className="title" level={5} style={{ margin: "unset" }}>
              {t("addTranslation.title")}
            </Title>
            <p>{t("addTranslation.description")}</p>
          </div>
          <div className="translate-part">
            <img
              src={secondPicture}
              alt="second picture"
              className="secondImage"
            />
            <div style={{ width: "100%" }}>
              <h2>{t("addTranslation.pasteOrUpload")}</h2>
              <Tabs
                defaultActiveKey="1"
                onChange={setActiveTab}
                style={{ marginBottom: 24 }}
              >
                <TabPane
                  className="tab-style-json"
                  tab={t("addTranslation.tabs.json")}
                  key="1"
                >
                  <TextArea
                    rows={9}
                    value={jsonInput}
                    onChange={(e) => setJsonInput(e.target.value)}
                  />
                </TabPane>

                <TabPane tab={t("addTranslation.tabs.file")} key="2">
                  <Dragger
                    name="file"
                    multiple={false}
                    beforeUpload={(file) => {
                      const isXls =
                        file.type === "application/vnd.ms-excel" ||
                        file.type ===
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                      if (!isXls) {
                        message.error(
                          t("addTranslation.invalidExcelFile", {
                            filename: file.name,
                          })
                        );
                        return Upload.LIST_IGNORE;
                      }
                      // You can directly set the fileList state here
                      setFileList([file as RcFile]);
                      // Return false to prevent automatic upload
                      return false;
                    }}
                    onChange={onFileChange}
                    fileList={fileList as any}
                    accept=".xls,.xlsx"
                  >
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined style={{ color: "#9B51E0" }} />
                    </p>
                    <p className="ant-upload-text">
                      {t("addTranslation.dragDropText")}
                    </p>
                    <p className="ant-upload-hint">
                      {t("addTranslation.dragDropHint")}
                    </p>
                  </Dragger>
                </TabPane>

                <TabPane tab={t("addTranslation.tabs.text")} key="3">
                  <TextArea
                    rows={9}
                    value={textInput}
                    onChange={(e) => setTextInput(e.target.value)}
                  />
                </TabPane>
              </Tabs>

              <h2>{t("addTranslation.selectLanguageToTranslate")}</h2>
              <Select
                showSearch
                placeholder={t("addTranslation.selectLanguagePlaceholder")}
                style={{ width: "100%", marginBottom: 24 }}
                value={language}
                onChange={handleLanguageChange}
                filterOption={(input, option: any) =>
                  option.props.children
                    .toString()
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {supportedLanguages?.map((lang) => (
                  <Option key={lang.id} value={lang.code}>
                    {lang.name} - {lang.code}
                  </Option>
                ))}
              </Select>

              <Button
                onClick={() =>
                  gate.requireTokens(textInput?.length ?? 0, translate)
                }
                className="translate-button"
                disabled={isLoading || normalizeRole(userRole) === "viewer"}
              >
                {isLoading ? (
                  <>
                    <Spin /> {t("addTranslation.waitButton")}
                  </>
                ) : (
                  t("addTranslation.translateButton")
                )}
              </Button>
            </div>
          </div>
        </div>
      </Content>
      <TranslationModal
        isVisible={isModalVisible}
        title=""
        content={
          <div
            className="modal-style"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img src={ModalImage} alt="image" />
            <h2
              style={{
                color: "#4A1C96",
                fontSize: "20px",
                fontFamily: "Poppins",
                fontWeight: "600",
                lineHeight: "24px",
                wordWrap: "break-word",
              }}
            >
              {t("addTranslation.resultModal.ready")}
            </h2>
            <p
              style={{
                fontFamily: "Poppins",
                fontWeight: "400",
                fontSize: "14px",
                lineHeight: "18px",
                textAlign: "center",
                color: "#808080",
              }}
            >
              {t("addTranslation.resultModal.successDescription", {
                language: supportedLanguages.find(
                  (lang) => lang.code === language
                )?.name,
              })}
            </p>
            {activeTab === "1" && (
              <p
                style={{
                  color: "#4A4A4A",
                  fontWeight: "bold",
                  fontFamily: "Poppins",
                }}
              >
                {t("addTranslation.resultModal.jsonHint")}
              </p>
            )}
            {activeTab === "3" && (
              <p
                style={{
                  color: "#4A4A4A",
                  fontWeight: "bold",
                  fontFamily: "Poppins",
                }}
              >
                {t("addTranslation.resultModal.textHint")}
              </p>
            )}
            {activeTab === "2" && (
              <p style={{ color: "#4A4A4A", fontWeight: "bold" }}>
                {t("addTranslation.resultModal.excelHint")}
              </p>
            )}
            <div
              className="buttons-style"
              style={{
                display: "flex",
                gap: "2rem",
                marginBottom: "1rem",
              }}
            >
              <Button
                className="download-button"
                style={{
                  width: "152px",
                  gap: "2rem",
                  backgroundColor: "#A072EB",
                  border: "unset",
                  color: "white",
                  fontSize: "12px",
                  fontFamily: "Poppins",
                  fontWeight: "600",
                  lineHeight: "19px",
                  height: "44px",
                }}
                onClick={() =>
                  gate.requirePaid(handleDownload, "Downloading translations")
                }
              >
                <DownloadOutlined /> {t("addTranslation.resultModal.download")}
              </Button>
              {activeTab !== "2" && (
                <Button
                  className="copy-button"
                  style={{
                    width: "152px",
                    color: "white",
                    gap: "2rem",
                    backgroundColor: "#4A1C96",
                    border: "unset",
                    fontSize: "12px",
                    fontFamily: "Poppins",
                    fontWeight: "600",
                    lineHeight: "19px",
                    height: "44px",
                  }}
                  onClick={handleCopy}
                >
                  <CopyOutlined /> {t("addTranslation.resultModal.copy")}
                </Button>
              )}
            </div>
            <a
              style={{
                color: "#A072EB",
                fontSize: "12px",
                fontFamily: "Poppins",
                fontWeight: "500",
                lineHeight: "24px",
                wordWrap: "break-word",
              }}
              onClick={handleCancel}
            >
              <ArrowLeftOutlined style={{ marginRight: "8px" }} />{" "}
              {t("addTranslation.resultModal.goBack")}
            </a>
          </div>
        }
        onOk={handleOk}
        onCancel={handleCancel}
      />
    </div>
  );
}

export default AITranslation;
